import { IBenefitTile, IPlan, IPriceTile } from "../../interfaces/api";
import Benefits from "./Benefits.component";
import ButtonsSection from "./ButtonsSection.component";
import DoctorsDrugs from "./DoctorsDrugs.component";
import PriceTile from "./PriceTile.component";

interface IAlignmentData {
  data: IPlan;
}

const AlignmentTile = ({ aligData }: { aligData: IAlignmentData }) => {
  const { data } = aligData;

  const pbpBenefitDesc = data.MonthlyPremiumAmountText;

  const [price, rest] =
    typeof pbpBenefitDesc === "string"
      ? pbpBenefitDesc
          .replace(/\\*\\n/g, "\n")
          .replace(/\\/g, "")
          .split("\n")
      : ["-", ""];
  const formattedPrice =
    price !== "-"
      ? `$${parseFloat(price.replace("$", "")).toFixed(2)}`
      : "No Data";

  const object1 = {
    pbpBenefitDesc: formattedPrice,
  };

  const object2 = {
    pbpBenefitDesc: rest,
  };

  const monthlyArray = [object1, object2];

  const priceTilesData: IPriceTile[] = [
    {
      label: "Monthly Premium",
      value: pbpBenefitDesc ? monthlyArray[0].pbpBenefitDesc : "No Data",
      desc: pbpBenefitDesc ? monthlyArray[1].pbpBenefitDesc : "No Data",
    },
    {
      label:
        data.HealthPlanlob === "HMO"
          ? "Maximum Out-of-Pocket"
          : "Maximum Out-of-Pocket<br /> In-Network",
      value: data.OutOfPocketMaxInNetworkAmount,
    },
    {
      label:
        data.HealthPlanlob === "HMO"
          ? "PCP Copay"
          : "PCP Copay<br /> In-Network",
      value: data.PCPCopayInNetworkAmount,
    },
    {
      label:
        data.HealthPlanlob === "HMO"
          ? "Specialist Copay"
          : "Specialist Copay<br /> In-Network",
      value: data.SpecialistCopayInNetworkAmount,
    },
  ];

  const benefitsData: IBenefitTile[] = [
    { label: "Vision", value: data.vision },
    { label: "Dental", value: data.dental },
    { label: "Prescription", value: data.prescription },
    { label: "24/7 Concierge", value: data.concierge },
    { label: "ACCESS On-Demand Concierge Card", value: data.concierge },
    // { label: "FLEX Allowance", value: data.flexAllowance },
    // { label: "Groceries", value: data.groceries },
    // { label: "Transportation", value: data.transportation },
    // { label: "Part B Rebate", value: data.partBRebate },
    // { label: "Caregiver Support", value: data.caregiver },
  ];

  const filteredBenefits = benefitsData.filter(
    (benefit) => benefit.value === true
  );
  const fullPlanName =
    data.pbpName + "(" + data.HealthPlanlob + "-" + data.pbp + ")";

  const uniquePlanID = fullPlanName + "||" + data.hcode + "_" + data.pbp;

  return (
    <div
      className="grid-y"
      style={{
        border: "1px solid #F5F9FD",
        boxShadow:
          "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
        marginTop: "30px",
      }}
    >
      <div className=" background-quaternary">
        <h3
          className="color-secondary text-uppercase"
          style={{ padding: "16px 0 19px 40px " }}
        >
          {data.pbpName} ({data.HealthPlanlob}-{data.pbp})
        </h3>
      </div>
      <div
        className="grid-x grid-margin-x"
        style={{
          padding: "34px 39px 13px",
          borderBottom: "1px solid #F5F9FD ",
        }}
      >
        {priceTilesData.map((priceTile: IPriceTile, index) => (
          <PriceTile data={priceTile} key={index} />
        ))}
      </div>
      <Benefits data={filteredBenefits} />
      <DoctorsDrugs data={data} />
      <ButtonsSection
        data={fullPlanName}
        componentId={uniquePlanID}
        fullData={data}
      />
    </div>
  );
};

export default AlignmentTile;
